import type { Release } from '../releases.ts';

export default {
  version: '1.0.0-rc.1',
  date: '2026-10-10',
  title: '1.0 release candidate 1',
  summary: [
    'Edit a recording while it still records, with ● REC in the bin and on clips',
    'The source viewer plays a recording up to what has been recorded so far',
    'Clips switch to the finished proxy by themselves when the recording ends',
    'An export waits for the recording to end, then renders from the finished original',
    'Fixed: release candidate versions are ordered correctly for storage agent updates',
  ],
  features: [
    'Edit a recording while it records: an asset still recording is in the sequence editor’s bin with ● REC and the length recorded so far',
    'The source viewer plays a recording up to what has been recorded, and In and Out can be marked anywhere within it; the waveform and filmstrip appear when the recording ends',
    'Clips from a recording go on the timeline like any other, with ● REC on the clip, and play in the sequence viewer with gain, fades and the audio meter',
    'When the recording ends, its clips switch to the finished proxy by themselves, and their waveforms appear',
    'Export a sequence with a clip from a recording still recording: the export waits with “Waiting for the recording to end”, then renders from the finished original',
    'Recordings play through hls.js in Chrome, Edge and Firefox, and with Safari’s own player in Safari',
    'Operations guide: Editing while recording',
  ],
  fixes: [
    'Version numbers with a release candidate (1.0.0-rc.1) are ordered correctly: after 0.99.1 and before 1.0.0, so a storage agent on a release candidate is offered the release',
  ],
} satisfies Release;
